import Images from "@Theme/Images";
import Styles from "./styles.module.scss";
import { useMemo, useState } from "react";
import Img1 from "@Assets/Images/img-pasang-loker-mudah.png";
import Img2 from "@Assets/Images/img-Filter-Kandidat-Dengan-Mudah.png";
import Img3 from "@Assets/Images/img-Cukup-3-Langkah-Untuk-Posting-Loker.png";

export default function OurAdvantagesAdsJobSeeker() {
  const excellencesData = useMemo(() => {
    return [
      {
        id: "01",
        image: Img1,
        title: "Pasang Loker Mudah",
        description:
          "Unggah serta kelola lowongan pekerjaan Anda dengan mudah dan cepat",
      },
      {
        id: "02",
        image: Img2,
        title: "Filter Kandidat Dengan Mudah",
        description:
          "Pencockan otomatis kualitas kandidat sesuai kebutuhan Anda",
      },
      {
        id: "03",
        image: Img3,
        title: "Cukup 3 Langkah Untuk Posting Loker",
        description: "Atur dan buat lowongan pekerjaan dengan mudah",
      },
    ];
  }, []);

  const [activeCarousel, setActiveCarousel] = useState(excellencesData);

  const handleSequenceCarousel = (clickedItem) => {
    const currentIndex = activeCarousel.findIndex(
      (item) => item.title === clickedItem.title
    );

    if (currentIndex !== 1) return;

    setAnimating(true);

    setTimeout(() => {
      setActiveCarousel((prev) => {
        const newArray = [...prev];
        const removed = newArray.splice(1, 1)[0];
        const first = newArray.shift();
        newArray.push(first);
        return [removed, ...newArray];
      });
      setAnimating(false);
    }, 600);
  };

  const [animating, setAnimating] = useState(false);

  return (
    <section className={Styles.container} id="OurAdvantagesAdsJobSeeker">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="251"
        height="256"
        viewBox="0 0 251 256"
        fill="none"
        className={Styles.leftClay}
      >
        <path
          d="M228.952 99.1912C248.02 148.596 268.118 210.042 226.813 242.971C185.818 275.654 132.221 239.969 88.3826 211.256C43.8075 182.061 -9.58733 147.692 1.47364 95.381C13.9017 36.6052 73.2784 -0.981607 133.048 0.0195181C183.747 0.868701 210.613 51.6727 228.952 99.1912Z"
          fill="#E1EDFE"
        />
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="599"
        height="565"
        viewBox="0 0 599 565"
        fill="none"
        className={Styles.rightClay}
      >
        <path
          d="M436.27 522.123C383.729 550.782 319.035 579.322 263.77 556.439C208.185 533.424 209.164 450.616 164.979 409.795C118.119 366.503 20.4131 376.812 2.91839 315.448C-14.2197 255.335 62.8574 210 92.2863 154.819C116.8 108.854 118.302 47.4191 161.438 18.2122C204.288 -10.8013 261.259 3.5686 312.956 5.40492C359.107 7.04421 403.094 13.2405 446.724 28.3457C497.788 46.0251 549.986 62.3949 588.122 100.671C634.048 146.765 692.762 201.807 683.793 266.285C674.72 331.506 591.945 355.08 546.147 402.416C507.707 442.147 484.8 495.653 436.27 522.123Z"
          fill="#E1EDFE"
        />
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="194"
        height="223"
        viewBox="0 0 194 223"
        fill="none"
        className={Styles.bottomClay}
      >
        <path
          d="M117.45 1.85339C138.207 9.91354 142.814 37.002 153.043 56.7827C160.489 71.183 163.047 86.6055 169.061 101.66C176.773 120.962 195.226 137.007 193.366 157.709C191.405 179.536 177.484 200.3 159.125 212.262C141.03 224.052 117.524 224.712 96.2521 220.985C77.4768 217.695 65.7285 199.376 47.8493 192.767C24.8046 184.248 -9.93962 198.08 -22.63 177.04C-35.0274 156.486 -3.3457 133.432 -2.40569 109.446C-1.3877 83.4698 -31.0153 56.3727 -17.042 34.4529C-3.49751 13.2055 30.8627 24.7818 55.3485 18.8466C76.6371 13.6865 97.03 -6.07591 117.45 1.85339Z"
          fill="#E1EDFE"
        />
      </svg>
      <div className={Styles.wrapperMainContain}>
        <div className={Styles.header}>
          <h1>Kenapa Anda Harus Menggunakan Kerja365?</h1>
          <div className={Styles.right}>
            <div className={Styles.images}>
              <img src={Images.PERMATA_LOGO} alt="permata-indonesia-logo" />
            </div>
            <span>Powered by Permata Indonesia</span>
          </div>
        </div>

        <section className={Styles.carouselCards}>
          {activeCarousel.map((c, idx) => (
            <img
              onClick={() => (idx === 1 ? handleSequenceCarousel(c) : {})}
              src={c.image}
              key={`carousel-img-${idx}`}
              alt={c.title}
              className={`${Styles.carouselImage} ${
                idx === 0 && animating
                  ? Styles.animateFirstToLeft
                  : "animating && idx !== 0 && Styles.animateEndToCenter"
              }`}
            />
          ))}
        </section>

        <div className={Styles.description}>
          <div>
            <h3>{activeCarousel[0].id}</h3>
            <h2>{activeCarousel[0].title}</h2>
            <p>{activeCarousel[0].description}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
